import { render, staticRenderFns } from "./diff_stats.vue?vue&type=template&id=6386d274&vue3"
import script from "./diff_stats.vue?vue&type=script&lang=js&vue3"
export * from "./diff_stats.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports